// Types
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const FETCH_PROPERTIES_SUCCESS = 'FETCH_PROPERTIES_SUCCESS'
export const FETCH_PROPERTIES_LOADING = 'FETCH_PROPERTIES_LOADING'
export const FETCH_PROPERTIES_ERROR = 'FETCH_PROPERTIES_ERROR'
export const FETCH_PROPERTY_SUCCESS = 'FETCH_PROPERTY_SUCCESS'
export const FETCH_PROPERTY_LOADING = 'FETCH_PROPERTY_LOADING'
export const FETCH_PROPERTY_ERROR = 'FETCH_PROPERTY_ERROR'
export const FETCH_USER_LOCATION_ERROR = 'FETCH_USER_LOCATION_ERROR'
export const FETCH_USER_LOCATION = 'FETCH_USER_LOCATION'
export const FETCH_LOCATION_ERROR = 'FETCH_LOCATION_ERROR'
export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS'
export const FETCH_LISTINGS_SUCCESS = 'FETCH_LISTINGS_SUCCESS'
export const FETCH_LISTINGS_LOADING = 'FETCH_LISTINGS_LOADING'
export const FETCH_LISTINGS_ERROR = 'FETCH_LISTINGS_ERROR'
export const FETCH_MAP_PROPERTIES_SUCCESS = 'FETCH_MAP_PROPERTIES_SUCCESS'
export const FETCH_MAP_PROPERTIES_LOADING = 'FETCH_MAP_PROPERTIES_LOADING'
export const FETCH_MAP_PROPERTIES_ERROR = 'FETCH_MAP_PROPERTIES_ERROR'
export const MAP_CENTER_CHANGE = 'MAP_CENTER_CHANGE'
export const MAP_ZOOM_CHANGE = 'MAP_ZOOM_CHANGE'
export const FETCH_FILTERTYPES_SUCCESS = 'FETCH_FILTERTYPES_SUCCESS'
export const FETCH_FILTERTYPES_ERROR = 'FETCH_FILTERTYPES_ERROR'
export const MAP_MARKER_HOVER = 'MAP_MARKER_HOVER'
export const MAP_CLUSTER_HOVER = 'MAP_CLUSTER_HOVER'
export const CHANGE_MAP = 'CHANGE_MAP'
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const PAGINATE_FROM_MAP = 'PAGINATE_FROM_MAP'
export const FETCH_ADCOUNCIL_SUCCESS = 'FETCH_ADCOUNCIL_SUCCESS'
export const FETCH_ADCOUNCIL_ERROR = 'FETCH_ADCOUNCIL_ERROR'
export const FETCH_ADCOUNCIL_LOADING = 'FETCH_ADCOUNCIL_LOADING'
export const SHOW_FLASH_MESSAGE = 'SHOW_FLASH_MESSAGE'
export const HIDE_FLASH_MESSAGE = 'HIDE_FLASH_MESSAGE'
export const UPDATE_PAGE_TYPE = 'UPDATE_PAGE_TYPE'
export const FETCH_SUBDOMAIN_SUCCESS = 'FETCH_SUBDOMAIN_SUCCESS'
export const FETCH_SUBDOMAIN_ERROR = 'FETCH_SUBDOMAIN_ERROR'
export const FETCH_SUBDOMAIN_LOADING = 'FETCH_SUBDOMAIN_LOADING'
export const FETCH_ZILLOW_ERROR = 'FETCH_ZILLOW_ERROR'
export const GET_CLUSTERS = 'GET_CLUSTERS'
export const UPDATE_SIMILAR_PROPERTIES = 'UPDATE_SIMILAR_PROPERTIES'
export const SORTING = 'SORTING'
export const ADD_MAP_MARKERS_TO_CACHE = 'ADD_MAP_MARKERS_TO_CACHE'
export const RESET_CACHED_MAP_MARKERS = 'RESET_CACHED_MAP_MARKERS'
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS'
export const IS_LOADING = 'IS_LOADING'
export const SHOW_SIGNIN_MODAL = 'SHOW_SIGNIN_MODAL'

export const FETCH_LOCAL_SIGNIN_SUCCESS = 'FETCH_LOCAL_SIGNIN_SUCCESS'
export const FETCH_LOCAL_SIGNIN_ERROR = 'FETCH_LOCAL_SIGNIN_ERROR'
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS'
export const FETCH_SOCIAL_SIGNIN_SUCCESS = 'FETCH_SOCIAL_SIGNIN_SUCCESS'
export const FETCH_SOCIAL_SIGNIN_ERROR = 'FETCH_SOCIAL_SIGNIN_ERROR'

export const UPDATE_USER_START = 'UPDATE_USER_START'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const UPDATE_USER_AVATAR_SUCCESS = 'UPDATE_USER_AVATAR_SUCCESS'

export const FETCH_USER_INFO_ERROR = 'FETCH_USER_INFO_ERROR'
export const IS_LOADING_STATUS = 'IS_LOADING_STATUS'
export const ADD_PROPERTIES_FAVORITES_SUCCESS = 'ADD_PROPERTIES_FAVORITES_SUCCESS'
export const ADD_PROPERTIES_FAVORITES__ERROR = 'ADD_PROPERTIES_FAVORITES__ERROR'
export const REMOVE_PROPERTIES_FAVORITES_SUCCESS = 'REMOVE_PROPERTIES_FAVORITES_SUCCESS'
export const REMOVE_PROPERTIES_FAVORITES_ERROR = 'REMOVE_PROPERTIES_FAVORITES_ERROR'
export const CREATE_NEW_USER_SUCCESS = 'CREATE_NEW_USER_SUCCESS'
export const CREATE_NEW_USER_ERROR = 'CREATE_NEW_USER_ERROR'
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS'
export const UPDATE_USER_SETTINGS_ERROR = 'UPDATE_USER_SETTINGS_ERROR'
export const IS_LOADING_USER_INFO = 'IS_LOADING_USER_INFO'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/
export const PHONE_REGEX = /^\d+?$/
export const ZIP_REGEX = /^\d{5}(-\d{4})?$/
export const MIN = 10
export const MAX = 10000
export const FLAG_PROPERTY = 'FLAG_PROPERTY'
export const FLAG_PROPERTY_LISTING = 'FLAG_PROPERTY_LISTING'

export const FLASH_MSG = {
  DOMAIN_UPDATE: 'Domain has been updated successfully',
}

export const VALIDATION_MSG = {
  FIELDS_NAME: {
    DOMAIN: 'domain',
  },
  REQUIRED_FIELD: 'Please enter your {fieldName}',
  INVALID_ENTRY: 'Please enter a valid {fieldName}',
}

export const ROUTES_PATH = {
  HOME: '/',
  LISTING: '/listings',
  PROPERTY: '/properties',
  PRICING: '/pricing',
  WELCOME: '/welcome',
}

export const MESSAGE = {
  NO_RESULTS_FOUND: {
    HOME: {
      TITLE: 'No Properties Found!',
      MSG: "We've found no new listings nearby your area.",
    },
    PROPERTIES_SEARCH: {
      TITLE: 'No Properties Found!',
      MSG: "We've found no properties within the search criteria you are looking for. Please modify your search location or filters.",
    },
    ADC_FR: {
      TITLE: 'No Properties Found!',
      MSG: "We've found no Active Listings for this Franchisee/Ad Council.",
    },
  },
  CONTACT_ADMIN: 'There has been an unexpected error. Please try again. If the error persists, please contact help@dealvestors.com',
  PREMIUM_MEMBER: 'Congratulations! You are now a premium member.',
  GOOGLE_ERROR: 'Some unexpected error ocurred while trying to connect with google',
  LOGIN_ERROR_MESSAGE: 'You must login to enable this feature.',
  INVESTMENT_LOCATION_TOOLTIP: 'These locations will be saved in your account.',
}
export const property = {
  query: `query { propertyFilters { name type value } }`,
}

export const OAUTH_PROVIDERS = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
  LOCAL: 'LOCAL',
}

export const TITLES = {
  PROFILE: 'Profile',
  SETTINGS: 'Settings',
  NOTIFICATIONS: 'Notifications',
  IMAGE: 'Change Image',
  SEARCHES: 'Saved',
  PREMIUM: 'Go Premium',
}

export const PLANS = {
  FREE: 'Free',
  PREMIUM: 'Premium',
}

export const REGISTER = 'Register'

export const LOADING_STRING = 'not'

export const SETTINGS = 'Settings'

export const SOLD = 'sale closing'

export const CONTRACT = 'sale contract'

export const ASSINGMENTS_LOCATION_LABEL = 'Undisclosed Location'



// WEBPACK FOOTER //
// ./src/constants/index.js